import { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { warningCount } from '../../lib/warnings.repository';
import { useRemote } from '../../lib/operations/use-remote';
import { useAccess } from '../../lib/access/access.context';
export function WarningBell() {
  const access = useAccess();
  const load = useCallback(
      (signal: AbortSignal) => {
        void access.data;
        return warningCount(signal);
      },
      [access.data]
    ),
    remote = useRemote(load, Boolean(access.data), true);
  const retry = remote.retry;
  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState !== 'hidden') retry();
    };
    window.addEventListener('nissei-warnings-refresh', refresh);
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => {
      clearInterval(timer);
      window.removeEventListener('nissei-warnings-refresh', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [retry]);
  if (!access.data) return null;
  return (
    <Link
      className="inline-flex items-center gap-2 rounded-field px-2 py-1 text-label text-primary hover:bg-muted"
      to="/admin/warnings"
      aria-label={
        remote.error
          ? 'Warnings: count unavailable'
          : `Warnings: ${remote.data ?? 'loading'} unread`
      }
    >
      <svg
        aria-hidden="true"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
        <path d="M10 21h4" />
      </svg>
      <span className="hidden sm:inline">Warnings</span>
      <span className="rounded-full bg-primary-100 px-2 py-0.5">
        {remote.error ? '!' : (remote.data ?? '…')}
      </span>
    </Link>
  );
}
